import React from 'react'
import _ from 'lodash'

import {FormattedRelative} from 'react-intl'
import {Cell} from 'fixed-data-table'

import DefaultCell from './DefaultCell.jsx'

const DateTimeCell = ({item, data, rowIndex, field, relative, row, ...props}) => {
   let val = _.get(data[rowIndex], field)

   if (val && false === relative) {
      return <Cell {...props}>{val}</Cell>
   } else if (val) {
      return <Cell {...props}><FormattedRelative value={val} /></Cell>
   } else {
      return <Cell {...props}>Never</Cell>
   }
}

DateTimeCell.propTypes = {
   ...DefaultCell.propTypes,
   relative: React.PropTypes.bool
}

export default DateTimeCell



// WEBPACK FOOTER //
// lib/ui/table/DateTimeCell.jsx